import { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";

async function onReadImage(files: any[], callback: (read: any) => void) {
  await Promise.all(
    files.map((item) => {
      const fileReader = new FileReader();
      fileReader.onloadend = () => {
        callback({ src: fileReader.result, file: item });
      };
      fileReader.readAsDataURL(item);
    })
  );
}
// Single
class SingleProps {
  value?: any;
  width?: number | string;
  height?: number | string;
  fit?: "cover" | "contain";
  circle?: boolean;
  onChange?: (value: any) => void;
  disabled?: boolean;
}

function Single({
  value,
  width = 200,
  height = 200,
  fit = "cover",
  circle = false,
  disabled = false,
  onChange = () => {},
}: SingleProps) {
  let dropzone = {
    onDrop: (files: any[]) =>
      onReadImage(files, (read) => {
        setImage(read);
        onChange(read);
      }),
    multiple: false,
    accept: "image/*",
  };
  let { getRootProps, getInputProps } = useDropzone(dropzone);

  let [image, setImage]: any = useState(null);

  return (
    <div
      className={
        "builder-image-picker" + (circle ? " builder-image-picker-circle" : "")
      }
      style={{ width, height }}
    >
      <input {...getInputProps()} disabled={disabled} />
      <label className="" {...getRootProps({})}>
        {image || value ? (
          <img src={image ? image?.src : value} style={{ objectFit: fit }} />
        ) : !disabled ? (
          <div className="image-default">
            <i className="fas fa-image" />
            <div className="mt-1">Fotoğraf Seç</div>
          </div>
        ) : null}
      </label>
    </div>
  );
}

export default { Single };
